import User from 'account/dto/User'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import i18n from 'simple-react-i18n'
import { authorizeContributors, authorizeFilter } from 'utils/HabilitationUtil'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import NumberField from '../../../../components/forms/NumberField'
import Select from '../../../../components/forms/Select'
import Textarea from '../../../../components/forms/Textarea'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import NetworkDto from '../../../../referencial/components/network/dto/NetworkDto'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import { getMatTypes } from '../../../../utils/MaterielUtils'
import { isFieldRequired } from 'materiel/utils/MaterielUtils'
import { ANTENNA_ID } from 'materiel/constants/MaterielConstants'
import { DATEACHAT_OBLIGATOIRE, NUMSERIE_OBLIGATOIRE } from 'materiel/constants/MaterielSettingRuleConstant'
import { antennaTypeShape } from '../dto/AntennaTypeShape'
import { antennaShape } from '../dto/AntennaShape'
import { Grid, Stack } from '@mui/material'

const AntennaPanel = ({
    active = false,
    disabled = true,
    antenna = {},
    contributors = [],
    accountUser = {},
    networks = [],
    antennaTypes = [],
    materielSettingRules = [],
    onChange = () => { },
}) => {
    const rules = materielSettingRules.filter(({ idMaterielType }) => idMaterielType === ANTENNA_ID)
    return (
        <Stack spacing={1}>
            <Grid container spacing={1}>
                <Grid size={3}>
                    <Select
                        options={getMatTypes(antennaTypes, antenna.antenneType)}
                        label={i18n.type}
                        onChange={value => onChange({ antenneType: value })}
                        value={antenna.antenneType}
                        nullLabel='&nbsp;'
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={3}>
                    <Input
                        title={i18n.serialNumber}
                        value={antenna.serialNumber}
                        onChange={value => onChange({ serialNumber: value })}
                        active={active}
                        disabled={disabled}
                        obligatory={isFieldRequired(rules, NUMSERIE_OBLIGATOIRE)}
                    />
                </Grid>
                <Grid size={3}>
                    <Input
                        title={i18n.immoNumber}
                        value={antenna.code}
                        onChange={value => onChange({ code: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={3}>
                    <Input
                        title={i18n.name}
                        value={antenna.name}
                        onChange={value => onChange({ name: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid size={6}>
                    <MultiContributorsAutocomplete
                        options={authorizeContributors(contributors, accountUser, antenna.manufacturerId)}
                        label={i18n.manufacturer}
                        onChange={code => onChange({ manufacturerId: code })}
                        values={antenna.manufacturerId}
                        keyLabel='labelDisplay'
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={6}>
                    <MultiContributorsAutocomplete
                        options={authorizeContributors(contributors, accountUser, antenna.providerId)}
                        label={i18n.provider}
                        onChange={code => onChange({ providerId: code })}
                        values={antenna.providerId}
                        keyLabel='labelDisplay'
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
            <Select
                options={authorizeFilter(networks, accountUser, antenna.networkCode)}
                label={i18n.network}
                onChange={value => onChange({ networkCode: value })}
                value={antenna.networkCode}
                nullLabel='&nbsp;'
                active={active}
                disabled={disabled}
            />
            <Grid container spacing={1}>
                <Grid size={3}>
                    <NumberField
                        title={`${i18n.cableLength} (m)`}
                        value={antenna.cableLength}
                        onChange={value => onChange({ cableLength: value })}
                        floatValue
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={3}>
                    <NumberField
                        title={i18n.mobility}
                        value={antenna.mobilityCode}
                        onChange={value => onChange({ mobilityCode: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={3}>
                    <NumberField
                        title={`${i18n.supplyTime} (${i18n.month})`}
                        value={antenna.supplyTime}
                        onChange={value => onChange({ supplyTime: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={3}>
                    <NumberField
                        title={i18n.warranty}
                        value={antenna.warantyLength}
                        onChange={value => onChange({ warantyLength: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} alignItems='center'>
                <Grid size={4}>
                    <SimpleDatePicker
                        id='manufactureDate'
                        label={i18n.manufactureDate}
                        value={antenna.manufactureDate}
                        onChange={v => onChange({ manufactureDate: v })}
                        disabled={disabled}
                        max={antenna.purchaseDate}
                    />
                </Grid>
                <Grid size={4}>
                    <SimpleDatePicker
                        id='purchaseDate'
                        label={i18n.purchaseDate}
                        value={antenna.purchaseDate}
                        onChange={v => onChange({ purchaseDate: v })}
                        disabled={disabled}
                        min={antenna.manufactureDate}
                        obligatory={isFieldRequired(rules, DATEACHAT_OBLIGATOIRE)}
                    />
                </Grid>
                <Grid size={4}>
                    <SimpleDatePicker
                        label={i18n.warrantyExpirationDate}
                        value={antenna.warantyLength && moment(antenna.purchaseDate).add(antenna.warantyLength, 'months').valueOf()}
                        disabled
                    />
                </Grid>
            </Grid>
            {/* <Grid container spacing={1} alignItems='center'>
            <Grid size={6}>
                <MultiContributorsAutocomplete
                    options={authorizeContributors(contributors, accountUser, antenna.owner)}
                    label={i18n.owner}
                    onChange={code => onChange({ owner: code })}
                    values={antenna.owner}
                    keyLabel='labelDisplay'
                    disabled={disabled}
                />
            </Grid>
            <Grid size={3}>
                <Checkbox
                    label={i18n.shared}
                    checked={antenna.shared}
                    onChange={value => onChange({ shared: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid> */}
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Input
                        title={i18n.locationSituation}
                        value={antenna.locationSituation}
                        onChange={value => onChange({ locationSituation: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
            <Textarea
                title={i18n.comment}
                value={antenna.comment}
                onChange={value => onChange({ comment: value })}
                active={active}
                disabled={disabled}
            />
        </Stack>
    )
}

AntennaPanel.propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onChange: PropTypes.func,
    antenna: antennaShape,
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    networks: PropTypes.arrayOf(PropTypes.instanceOf(NetworkDto)),
    antennaTypes: PropTypes.arrayOf(antennaTypeShape),
    materielSettingRules: PropTypes.arrayOf(PropTypes.object),
    accountUser: PropTypes.instanceOf(User),
}

const mapStateToProps = store => ({
    contributors: store.ContributorReducer.contributors,
    networks: store.NetworkReducer.networks,
    antennaTypes: store.AntennaReducer.antennaTypes,
    materielSettingRules: store.MaterielReducer.materielSettingRules,
    accountUser: store.AccountReducer.accountUser,
})

export default connect(mapStateToProps)(AntennaPanel)
